import TachesController from './taches.controller';

export default {
    template: require('./taches.tpl.html'),
    controller: TachesController
};
